import {
  Clock,
  XCircle,
  Ban,
  AlertCircle,
} from 'lucide-react'

export function formatDate(dateString: string | null): string {
  if (!dateString) return '—'
  const date = new Date(dateString)
  return date.toLocaleDateString('de-DE', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  })
}

export function formatDateTime(dateString: string | null): string {
  if (!dateString) return '—'
  const date = new Date(dateString)
  return date.toLocaleString('de-DE', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}

export function formatCurrency(cents: number, currency: string): string {
  const amount = cents / 100
  return new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: currency || 'EUR',
  }).format(amount)
}

export function getIncidentIcon(incidentType: string | null) {
  switch (incidentType) {
    case 'delay':
      return Clock
    case 'cancel':
      return XCircle
    case 'denied_boarding':
      return Ban
    case 'other':
      return AlertCircle
    default:
      return AlertCircle
  }
}
